import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output, Renderer2
} from '@angular/core';
import {animationFrameScheduler, Subscription} from 'rxjs';

import {GetRegion2Css, GetRegion2Name} from '../../defines/client.const';
import {GetFourTonesArray} from "../../defines/gukeo.func";
import {Saseung3} from "../../models/saseung3.model";
import {clickOutsideLinkMixin} from "../../mixins/click-outside.mixin";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {Saseung3HanjaService} from "../../services/saseung3-hanja/saseung3-hanja.service";

const MAX_HANJA_ITEM = 5;
const POPUP_HEIGHT_DELTA = 60;

@Component({
  selector: 'app-word-hanja-popup',
  templateUrl: './word-hanja-popup.component.html',
  styleUrls: ['./word-hanja-popup.component.scss']
})
export class WordHanjaPopupComponent extends clickOutsideLinkMixin implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class') hostClass = 'link-popup popup-connect type-shadow';
  @Input() hanja?: string;
  @Output() close = new EventEmitter<string | null>();
  @Output() viewInit = new EventEmitter<HTMLElement>();

  protected readonly GetRegion2Css = GetRegion2Css;
  protected readonly GetRegion2Name = GetRegion2Name;
  protected readonly GetFourTonesArray = GetFourTonesArray;

  protected countPopupItems = MAX_HANJA_ITEM;
  private load$: Subscription | null = null;
  listSaseung3: Array<Saseung3> | null = null;
  hasError = false;
  private totalSaseungCount = 0;

  public get IsLoading(): boolean {
    return this.load$ !== null;
  }

  public getLeftHanjaCount(): number {
    return this.totalSaseungCount - this.countPopupItems;
  }

  public getMoreTxt(): string | null {
    const leftHunCount = this.getLeftHanjaCount();
    if (leftHunCount > 0) {
      return `${leftHunCount}개의 훈이 더 있습니다.`;
    }
    return null;
  }

  constructor(
    public elementRef: ElementRef,
    public renderer: Renderer2,
    public globalEventSvc: GlobalEventService,
    private cdRef: ChangeDetectorRef,
    private saseung3HanjaSvc: Saseung3HanjaService,
  ) {
    super(elementRef, renderer, globalEventSvc);

    console.warn('WordHanjaPopupComponent.constructor()');
  }

  ngOnInit(): void {
    // mixin을 이용해서 팝업창 외부를 클릭했는지 체크한다.
    this.coInit(() => this.close.emit(null));

    if (this.hanja) {
      this.hasError = false;
      this.listSaseung3 = null;
      this.saseung3HanjaSvc.ResetList({hanja: this.hanja});
      this.load$ = this.saseung3HanjaSvc.GetNextList().subscribe(
        () => {
          const list = this.saseung3HanjaSvc.getList();
          this.totalSaseungCount = this.saseung3HanjaSvc.getTotalCount() ?? 0;
          this.listSaseung3 = list?.slice(0, MAX_HANJA_ITEM) ?? null;
          console.warn('WordHanjaPopupComponent.ngOnInit: loaded', this.listSaseung3);
        },
        (error: unknown) => {
          console.error('WordHanjaPopupComponent.ngOnInit: error', error);
          this.hasError = true;
          this.load$ = null;
        },
        () => {
          this.load$ = null;
        }
      );
    }
  }

  ngAfterViewInit(): void {
    // TODO: 이 부분은 mixin에서 사용하고 있지만 처리하는 작업은 없다. 책상형에서 사용하지만 앱에서는 필요하지 않아 보인다.
    // this.viewInit.emit(this.elementRef.nativeElement.firstChild);
  }

  ngOnDestroy(): void {
    this.coDestroy();

    // 로딩 하고 있으면, 로딩을 중단한다.
    if (this.load$) {
      this.load$.unsubscribe();
      this.load$ = null;
    }
  }

  public onCloseMore($event: MouseEvent): void {
    console.warn('WordHanjaPopupComponent.onCloseMore');

    $event.stopPropagation();
    $event.preventDefault();

    this.close.emit(this.hanja);
  }


  /**
   * 상위 요소로 이벤트 전파를 막는다.
   * @param event
   */
  onVoid(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    // this.globalEventSvc.Click(event);
  }

  onItemAfterViewInit() {
    const componentHeight = this.elementRef.nativeElement.offsetHeight;
    const windowHeight = window.innerHeight;

    console.log('WordHanjaPopupComponent.onItemAfterViewInit', componentHeight, windowHeight, this.elementRef.nativeElement);

    if (componentHeight > windowHeight - POPUP_HEIGHT_DELTA) {
      console.warn('remove display', componentHeight, windowHeight - POPUP_HEIGHT_DELTA);
      animationFrameScheduler.schedule(() => {
        --this.countPopupItems;
        this.cdRef.detectChanges();
      });
    }
  }

  onClose($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.close.emit(null);
  }

  /**
   * 한자 문자열을 개별 문자 배열로 변환 (hanja-content 패턴)
   */
  protected getHanjaChars(hanja: string): string[] {
    return Array.from(hanja);
  }

  /**
   * meaning 필드를 파이프(|)로 분리하여 훈 배열로 반환
   */
  private getHunParts(saseung: Saseung3): string[] {
    if (!saseung?.meaning) return [];
    return saseung.meaning.split('|');
  }

  /**
   * 훈에서 첫 번째 훈만 추출
   */
  protected getFirstHun(saseung: Saseung3): string {
    return this.getHunParts(saseung)[0] ?? '';
  }

  /**
   * 첫 번째를 제외한 나머지 훈 반환
   * 원본: 파이프(|)로 구분된 meaning 문자열
   * 출력: 중간점(' · ')으로 구분된 문자열
   */
  protected getRestHun(saseung: Saseung3): string {
    return this.getHunParts(saseung).slice(1).join(' · ');
  }
}
